import { useEffect } from 'react';
/**
 * [F-12 T-2.10 / D-4] useDocumentMeta — mount-kor frissíti vagy létrehozza a
 * `<meta property="og:image">` és `<meta property="og:description">` tageket a `document.head`-ben,
 * unmount-kor visszaállítja az eredeti értékeket (vagy törli, ha új tag volt).
 *
 * KORLÁT: csak a böngészőben futó JS megosztáshoz (navigator.share) hat — a social crawler-ek
 * (Facebook, LinkedIn) SSR-ből nézik a meta tageket → F-13 (külön feature) feladata, hogy
 * `Main.php` job-route esetén job-specifikus og: értékeket adjon a `career.tpl`-nek.
 */
export function useDocumentMeta({ ogImage, ogDescription }) {
    useEffect(() => {
        if (typeof document === 'undefined')
            return;
        const restores = [];
        if (typeof ogImage === 'string' && ogImage !== '') {
            restores.push(setOrCreateMetaProperty('og:image', ogImage));
        }
        if (typeof ogDescription === 'string' && ogDescription !== '') {
            restores.push(setOrCreateMetaProperty('og:description', ogDescription));
        }
        return () => {
            restores.forEach(restore => restore());
        };
    }, [ogImage, ogDescription]);
}
/**
 * Meta tag set vagy create. Visszaadja a restore függvényt unmount-hoz.
 */
function setOrCreateMetaProperty(property, value) {
    const selector = `meta[property="${property}"]`;
    const existing = document.head.querySelector(selector);
    if (existing) {
        const previousValue = existing.getAttribute('content') || '';
        existing.setAttribute('content', value);
        return () => {
            // Csak akkor állítjuk vissza, ha közben más nem írta felül
            if (existing.getAttribute('content') === value) {
                existing.setAttribute('content', previousValue);
            }
        };
    }
    const created = document.createElement('meta');
    created.setAttribute('property', property);
    created.setAttribute('content', value);
    document.head.appendChild(created);
    return () => {
        // Csak akkor távolítjuk el, ha közben más nem írta felül
        if (created.getAttribute('content') === value && created.parentNode === document.head) {
            document.head.removeChild(created);
        }
    };
}
